import '../Job';

import base from "@/fstore";
import validation from "@/fstore/validation";
import helpers from '@/fstore/helpers';
import moment from 'moment';

const db = base.db;
const collection = "job";
const baseModel = db.collection(collection);

const template = {
  user: {
    desc: "The user account of the candidate",
    type: "object",
    required: true
  },
  dateAdded: {
    desc: "The date the user was added to the saved job list",
    type: "object",
    default: new Date()
  },
  dateQuestionnaireSent: {
    desc: "The date the user was sent the questionnaire, or false",
    type: "object",
    default: null
  }
}

const _getModel = (jobId) => {
  return baseModel.doc(jobId).collection('candidate');
}

const add = async (jobId, userId) => {
  const model = _getModel(jobId);
  const candidate = helpers.getTemplate(template);

  candidate.user = db.collection('userData').doc(userId);

  const response = await validation.validateModel(model, candidate, template);
  if (!response.errors.length) {
    const newDoc = await model.add(response.doc);
    response.doc.uid = newDoc.id
  }

  console.log(response);
  return response;
}

const remove = async (jobId, userId) => {

}

const getSaved = async (jobId) => {
  const candidates = await baseModel.doc(jobId).collection("candidates").get();

  console.log(candidates);
}

const hasUser = (jobId, userId) => {
  const candidate = baseModel.doc(jobId).collection("candidate").doc(userId).get();

  candidate.then(doc => {
    console.log("DOC: ", doc);
  });

  return true;
  // return candidate.exists;
}


export default {
  add,
  remove,
  getSaved,
  hasUser
}